import styled from 'styled-components';

export const SectionBase = styled.div`
	flex-grow: 1;
	padding-left: 62px;
	padding-right: 62px;
	padding-top: 42px;
	padding-bottom: 50px;
	background-color: ${({ theme }) => theme.gray[0]};
	color: ${({ theme }) => theme.gray[1000]};
	overflow-y: auto;
`;

export const SectionHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 20px;
	gap: 20px;
`;

export const SectionTitle = styled.h2`
	font-size: 36px;
	font-weight: 600;
	margin: 0;
	margin-bottom: 12px;
	color: ${({ theme }) => theme.gray[1000]};
`;

export const SectionContent = styled.div`
	font-size: 16px;
	line-height: 1.5;
	color: ${({ theme }) => theme.gray[800]};

	p {
		margin-bottom: 10px;
	}
`;

export const SubSectionTitle = styled.h3`
	font-size: 18px;
	font-weight: 600;
	color: ${({ theme }) => theme.gray[900]};
	margin: 24px 0 16px 0;
`;

export const SelectToggle = styled.button<{ $selected: boolean }>`
	font-size: 13px;
	color: ${({ theme, $selected }) => ($selected ? theme.blue[700] : theme.gray[600])};
	background-color: ${({ theme, $selected }) => ($selected ? theme.blue[300] : theme.gray[100])};
	padding: 4px 12px;
	border-radius: 12px;
	border: 1px solid ${({ theme, $selected }) => ($selected ? theme.blue[500] : 'transparent')};
	font-weight: 500;
	transition: all 0.15s ease;

	&:hover {
		background-color: ${({ theme, $selected }) => ($selected ? theme.blue[300] : theme.gray[200])};
		color: ${({ theme, $selected }) => ($selected ? theme.blue[700] : theme.gray[1000])};
	}
`;
